import { render, staticRenderFns } from "./RelationAdd.vue?vue&type=template&id=2772d5c3&"
import script from "./RelationAdd.vue?vue&type=script&lang=js&"
export * from "./RelationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports